import gql from 'graphql-tag';
import commonFragments from './common.fragments';
import cancellationPrimerFragments from '../../components/cancellation-primer/cancellation-primer.fragments';
import paymentContainerFragments from '../../components/payment-apollo/payment-container/payment-container.fragments';
import priceDetailsFragments from '../../components/price-details/price-details.fragments';
import rulesStepFragments from '../../components/rules-step/rules-step.fragments';
import vasStepFragments from '../../components/vas-products/vas-step/vas-step.fragments';
import {
    paymentMethodsContainerFragments,
    billingAddressContainerFragments,
    ctaDetailsFragments,
} from '@homeaway/react-payment-module';
/**
 * Common fields requested by:
 * - clientside query: checkout-query
 * - server-side query: traveler-checkout/mutations/create.js, traveler-checkout/mutations/create-payment.js, traveler-checkout/mutations/create-vas.js
 /**
 * Common fields requested by clientside query, checkout-query, and server-side query, traveler-checkout/mutations/create.js
 */

const createCheckoutFragments = {
    CheckoutExperienceModel: gql`
        fragment CreateCheckoutCheckoutExperienceModel on CheckoutExperienceModel {
            # Common fragments
            ...CheckoutInputsCheckoutExperienceModel
            ...ClientValidatorsCheckoutExperienceModel
            ...DisclosuresCheckoutExperienceModel
            ...PayloadCheckoutExperienceModel
            ...ReservationInformationCheckoutExperienceModel
            ...SiteSettingsCheckoutExperienceModel
            ...TextsCheckoutExperienceModel
            ...TravelerInformationCheckoutExperienceModel
            ...TripInformationCheckoutExperienceModel
            ...coBccEligibilityCheckoutExperienceModel
            ...coBccConfigsCheckoutExperienceModel
            # Component level fragments
            ...CancellationPrimerCheckoutExperienceModel
            ...PaymentContainerCheckoutExperienceModel
            ...RulesStepCheckoutExperienceModel
            ...VasStepCheckoutExperienceModel
            # Imported fragments
            ...BillingAddressContainerCheckoutExperienceModel
            ...PaymentMethodsContainerCheckoutExperienceModel
            ...PriceDetailsCheckoutExperienceModel
            ...TraderIdentificationCheckoutExperienceModel
        }
        ${commonFragments.CheckoutInputs.CheckoutExperienceModel}
        ${commonFragments.ClientValidators.CheckoutExperienceModel}
        ${commonFragments.Disclosures.CheckoutExperienceModel}
        ${commonFragments.Payload.CheckoutExperienceModel}
        ${commonFragments.ReservationInformation.CheckoutExperienceModel}
        ${commonFragments.SiteSettings.CheckoutExperienceModel}
        ${commonFragments.Texts.CheckoutExperienceModel}
        ${commonFragments.TravelerInformation.CheckoutExperienceModel}
        ${commonFragments.TripInformation.CheckoutExperienceModel}
        ${commonFragments.coBccEligibility.CheckoutExperienceModel}
        ${commonFragments.coBccConfigs.CheckoutExperienceModel}
        ${cancellationPrimerFragments.CheckoutExperienceModel}
        ${paymentContainerFragments.CheckoutExperienceModel}
        ${rulesStepFragments.CheckoutExperienceModel}
        ${vasStepFragments.CheckoutExperienceModel}
        ${billingAddressContainerFragments.CheckoutExperienceModel}
        ${paymentMethodsContainerFragments.CheckoutExperienceModel}
        ${priceDetailsFragments.CheckoutExperienceModel}
        ${ctaDetailsFragments.CheckoutExperienceModel}
    `,
};

export default createCheckoutFragments;
